<template>
  <div class="section" >
      <div class="mains">
        <div class="main">
        <div class="list_items">
          <div class="list_item" v-for="(item,index) in lists" :key="index">
            <div class="icons"><span class="icon"></span><p>{{item.title}}</p></div>
            <p class="write">{{item.content}}</p>
            <div class="line"></div>
          </div>
        </div>
        <div class="more" @click="soft11()">MORE+</div>
      </div>
      </div>
  </div>
</template>

<script>

export default {
  name:"Four",
  data(){
    return{
      lists:[
        {title:'后台管理系统',content:'免费后台管理系统、代理、商家、子账号分管功能，轻松管理账目，多种财务报表，随时随地查看订单和机器运营的情况'},
        {title:'资金安全保障',content:'维码器与腾讯、支付宝、兴业银行、汇卡商务全面战略合作，维码器系统直接调用银行和腾讯、支付宝接口、多方对账实现零误差，100%保障资金安全'},
        {title:'消息推送功能',content:'订单支付，设备异常，订单异常，礼品数量不足，消费者提交申诉等系统主动推送消息至商家微信'},
        {title:'会员卡功能',content:'虚拟会员卡功能，帮助商家快速回笼资金，可设置充值优惠，吸引并留住客户'},
        {title:'自动分账功能',content:'系统将自动按比例分账配套子账号共同查账对账功能，轻松解决合伙人分账困难繁琐等问题'},
        {title:'公众号吸粉功能',content:'每个商家都可设置关注公众号赠币营销活动，服务号，订阅号均可'},
      ]
    }
  },
  methods:{
    soft11(){
      this.$router.push({path:'/software'});
      this.$store.state.d4 = '';
    }
  },
 watch:{
        '$route':function(to,from){
　　　　　　　　document.body.scrollTop = '0';
              document.documentElement.scrollTop = '0';
        }
},
}
</script>

<style scoped>
.section{
    width: 100%;
    height: 100%;
    background: url('../assets/secondp/bg.png') -788px -788px no-repeat,url('../assets/secondp/bg.png') 1168px 300px no-repeat;
    z-index: 99;
}
.mains{
    position: absolute;
    width: 100%;
    top: 10%;
}
  .main{
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    width: 1200px;
  }
  .list_items{
        overflow: hidden;
        margin-left: auto;
    margin-right: auto;
    width: 1055px;
  }
.main .list_items .list_item{
    /* width: calc((100% - 222px) / 3); */
    box-sizing: border-box;
    width: 320px;
	height: 320px;
	background-color: #ffffff;
	box-shadow: 0px 2px 20px 0px rgba(219, 219, 219, 0.3);
	border-radius: 20px;
    text-align: center;
    float: left;
    background: #fff;
    padding: 36px 37px 0px;
    margin-right: 31px;
    margin-bottom: 30px;
    position: relative;
    top: 0px;
    left: 0px;
}
.main .list_items .list_item:nth-child(4),.main .list_items .list_item:nth-child(5),.main .list_items .list_item:nth-child(6){
  margin-bottom: 0px;
}
.icons .icon{
    width: 60px;
    height: 60px;
    display: block;
    background-image: url('../assets/fourp/1.png');
    /* background-size: cover; */
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
}
.list_items .list_item .icons p{
  font-family: 微软雅黑;
	font-size: 18px;
	font-weight: bold;
	line-height: 40px;
	letter-spacing: 0px;
	color: #333333;
}
.list_item .write{
  font-family: 微软雅黑;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	letter-spacing: 0px;
	color: #666666;
  margin-top:3px;
}
.list_item .line{
  width: 57px;
	height: 4px;
	background-color: #198bfe;
	border-radius: 2px;
    margin-left: auto;
    margin-right: auto;
        position: absolute;
    bottom: 26px;
    left: 130px;
}
  .more{
    width: 168px;
	height: 65px;
	background-color: #252525;
	border-radius: 6px;
    background: #252525;
    text-align: center;
    line-height: 65px;
    color: #fff;
    margin-left: auto;
    margin-right: auto;
    margin-top:50px;
    font-family: Arial;
    cursor: pointer;
  }
  .more:hover{
    background: #198bfe;
  }
  .list_items .list_item:hover{
    color:#fff;
    background: -webkit-linear-gradient(top, #46b8fe,#034dfe); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(bottom, #46b8fe, #034dfe); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(bottom , #46b8fe, #034dfe); /* Firefox 3.6 - 15 */
    background: linear-gradient(to bottom, #46b8fe , #034dfe); /* 标准的语法 */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#46b8fe', endColorstr='#034dfe',GradientType=0 ); 
  }
  .list_items .list_item:hover .write,.list_items .list_item:hover .icons p{
    color: #fff;
  }
  .list_items .list_item:hover .line{
    background: #FFF;
  }
  .list_items .list_item:nth-child(1) .icons .icon{
        background-position: 0px 0px;
  }
  .list_items .list_item:hover:nth-child(1) .icons .icon{
    background-position: -65px 0px;
    
  }
   .list_items .list_item:nth-child(2) .icons .icon{
        background-position: -147px 0px;
  }
  .list_items .list_item:hover:nth-child(2) .icons .icon{
    background-position: -219px 0px;
  }
   .list_items .list_item:nth-child(3) .icons .icon{
        background-position: -10px -78px;
  }
  .list_items .list_item:hover:nth-child(3) .icons .icon{
    background-position: -76px -78px;
  }
  .list_items .list_item:nth-child(4) .icons .icon{
        background-position: -152px -78px;
  }
  .list_items .list_item:hover:nth-child(4) .icons .icon{
    background-position: -245px -78px;
  }
  .list_items .list_item:nth-child(5) .icons .icon{
        background-position: -10px -164px;
  }
  .list_items .list_item:hover:nth-child(5) .icons .icon{
    background-position: -76px -164px;
  }
  .list_items .list_item:nth-child(6) .icons .icon{
        background-position: -157px -166px;
  }
  .list_items .list_item:hover:nth-child(6) .icons .icon{
    background-position: -243px -166px;
  }

    @media screen and (max-height: 800px){
    .mains{
            transform: scale(0.75);
            top:-8%;
        }
  }
   @media screen and (max-height: 700px){
    .mains{
            transform: scale(0.65);
            top:-8%;
        }
  }
  @media screen and (max-width:768px){
    .mains{
      display: none;
    }
    .section{
      width: 100%;
      /* height: 100%; */
      height: calc(100% - 48px);
      background: url('../assets/phone/04.jpg') no-repeat;
      background-size: 100% 100%;
      margin-top: 48px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Four.vue